export const VOUCHER_CODE_MAX_LENGTH = 12;
